export default __webpack_public_path__ + "static/media/default_project_preview.24a328a1.png";